import {inject, injectable} from 'inversify';

import type {
  CoachTaskExpandedFieldsCommon,
  TaskExpandedFieldsCommon,
} from '../../../../api/task';
import type {Expand} from '../../../../api/types';

import {coachTaskExpandCommon, taskExpandCommon} from '../../../../api/task';
import {EnvProviderService} from '../../../system/env/EnvProvider.service';
import {BaseExpandJrpc} from '../../Base/mappers/Base.expand.jrpc';

@injectable()
export class TaskExpandJrpc extends BaseExpandJrpc {
  constructor(@inject(EnvProviderService) env: EnvProviderService) {
    super(env);
  }

  getByEnvForClient(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = taskExpandCommon;
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }

  getByEnvForCoach(key?: BaseExpandJrpc.EnvKey): Expand {
    const base: Expand = coachTaskExpandCommon;
    const core: Expand = base;
    const b2b: Expand = base;

    return this.resolve({b2b, core, key});
  }
}

export namespace TaskExpandJrpc {
  export type ExpandedFieldsClient = TaskExpandedFieldsCommon;

  export type ExpandedFieldsCoach = CoachTaskExpandedFieldsCommon;
}
